/* eslint-disable react/destructuring-assignment */
/* eslint-disable max-classes-per-file */
import React from 'react'
import Select from 'react-select'
import { FormItem, FormItemProps } from './FormItem'
import { IField, getRequiredError } from './FieldValidation'
import { Option } from './Options'
import { selectStyles } from './SelectField'
import { ErrorText } from './ErrorText'

export interface MultiSelectFieldProps<V> extends FormItemProps {
    id: string
    onChange: { (value: V[]): any },
    value: V[],
    dataSource: Option<V>[]
    required?: boolean
    requiredMessage?: string
    disabled?: boolean
    position?: string
    maxCapacity?: number
}

export interface MultiSelectFieldState {
    errorText?: string
}

export class MultiSelectField<V> extends React.Component<MultiSelectFieldProps<V>, MultiSelectFieldState> implements IField {
  input: React.RefObject<any> = React.createRef()

  constructor(props?: MultiSelectFieldProps<V>, context?: any) {
    super(props, context)

    this.state = {
    }
  }

  componentDidUpdate(prevProps: MultiSelectFieldProps<V>, prevState: MultiSelectFieldState) {
    if (this.props.value != prevProps.value) {
      if (this.state.errorText) {
        this.validate(() => { })
      }
    }
  }

  render() {
    let value: Option<V>[] = []
    if (this.props.dataSource && this.props.value) {
      for (let data of this.props.dataSource) {
        if (this.props.value.indexOf(data.value) >= 0) {
          value.push(data)
        }
      }
    }

    if (this.props.preview) {
      let temp = ''
      for (let v of value) {
        if (temp.length > 0) {
          temp += ', '
        }
        temp += v.label
      }
      return (
        <FormItem {...this.props} inputId={this.props.id} errorMessage={this.state.errorText}>
          <div className="form-value">{temp ? temp : '--'}</div>
        </FormItem>
      )
    }

    return (
      <FormItem {...this.props} inputId={this.props.id}>
        <Select
          styles={selectStyles(true, !!this.state.errorText, this.props.position)}
          id={this.props.id}
          options={this.props.dataSource}
          value={value}
          isClearable
          isMulti
          onChange={(v: Option<V>[]) => {
            if (this.props.maxCapacity && v.length > this.props.maxCapacity) {
              return // Ignore further additions if maxCapacity is reached
            }
            this.props.onChange(v === null ? null : v.map(r => r.value))
          }}
          isDisabled={this.props.disabled}
        />
        <ErrorText text={this.state.errorText} />
      </FormItem>
    )
  }

  focus() {
    if (this.input.current) {
      const selectElement = this.input.current as any
      if (selectElement && selectElement.focus) {
        selectElement.focus()
      }
    }
  }

  hasValue(): boolean {
    let res = false
    if (this.props.dataSource && this.props.value) {
      for (let data of this.props.dataSource) {
        if (this.props.value.indexOf(data.value) >= 0) {
          res = true
          break;
        }
      }
    }
    return res
  }

  getErrorText(): string {
    if (this.props.required === true) {
      if (!this.hasValue()) {
        return getRequiredError(this.props)
      }
    }
    return null
  }

  validate(callback: { (res: boolean): any }, focus?: boolean) {
    let errorText = this.getErrorText()
    this.setError(errorText, () => {
      if (this.props.errorMessage || errorText) {
        if (focus === true) {
          this.focus()
        }
      }
      callback && callback((this.props.errorMessage || errorText) ? false : true)
    })
  }

  setError(errorText?: string, callback?: { (): any }) {
    this.setState({ errorText }, callback)
  }

  // expose disabled prop, so we can bypass validation if disabled.
  // eslint-disable-next-line react/no-unused-class-component-methods
  isDisabled() {
    return this.props.disabled
  }
}

export class TextMultiSelectField extends MultiSelectField<string> { }

export class NumericMultiSelectField extends MultiSelectField<number> { }

export class BooleanMultiSelectField extends MultiSelectField<boolean> { }
